<template> 
<div>
  <span class="title">Bitree Painter</span>
  <div class="container">
    <div class="above-container">  
      <div class="border">
        <div class="option-container">
          <div style="height:260px;width:100%;overflow-x:hidden;">  
            <table>
              <tr class="item-line">
                <td class="item-name">缩放</td>
                <td><input id="scale" type="range" value="2" max="3" min="1" step="0.1" v-on:input="SetScale()"></td>
              </tr>
              <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">字号</td>
                <td><input id="font-size" type="range" value="20" max="30" min="10" v-on:input="SetFontSize()"></td>
              </tr>
              <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">间距</td>
                <td><input id="space" type="range" value="40" max="50" min="30" v-on:input="SetSpace()"></td>
              </tr>
              <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">层高</td>
                <td><input id="level-space" type="range" value="50" max="70" min="30" v-on:input="SetlevelSpace()"></td>
              </tr>
              <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">线宽</td>
                <td><input id="linewidth" type="range" value="2" max="3" min="1" step="0.01" v-on:input="SetLineWidth()"></td>
              </tr>  
              <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">水平</td>
                <td><input id="movex" type="range" value="200" max="1000" min="0" v-on:input="SetX()"></td>
              </tr>
               <tr class="hr"/>
              <tr class="item-line">
                <td class="item-name">垂直</td>
                <td><input id="movey" type="range" value="50" max="400" min="0" v-on:input="SetY()"></td>
              </tr>    
              <tr class="hr"/>
            </table>
          </div>
          <hr style="margin:0; border:0.5pt solid lightgrey;">
          <div v-bind:class="{'table-button':true,'active':this.buttonActive}" 
            v-on:mouseover="this.buttonActive=true;"
            v-on:mouseleave="this.buttonActive=false">
            <span style="margin-left:40%;">保存</span>
          </div>
        </div>
        <div class="input-container">
          <div class="input-box" contenteditable="true" v-on:input="this.Input()">4b[2r[1b][3b]][5b]</div>
          <div class="output-box" v-html="OutPut"></div>
        </div>
        <div class="style-container">
          <div class="style-list">
            <table >
              <tbody v-for="(s,i) in this.style" v-bind:key="i">
                <tr v-bind:class="{'style-item':true, 'active':s.active}"
                  v-on:click="ChangeStyle(i)">  
                  <span style="padding-left:5%">{{s.name}}</span>
                </tr>
                <tr class="hr"/>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <canvas width="1020" height="400"></canvas>
  </div>
</div>  
</template>

<script>
export default {
    data:function(){
        return{
          style:[
            {name:"红黑树",font:20,textlength:2,active:true},
            {name:"纯色树",font:20,textlength:2,active:false}
          ],
          scale:2,//放缩
          fontSize:20,//字体
          space:40,//圆间距
          lineWidth:2,
          levelSpace:50,
          x:200,
          y:50,
          code:'',
          message:[],
          curStyle:0,
          buttonActive:false,
          Level:null,//每层的节点
          ctx:null,
        }
    },
    mounted:function(){
      this.Input();
    },
    methods:{
      SetScale:function(){
        this.scale=document.getElementById('scale').value;
        this.Input();
      },
      SetFontSize:function(){
        this.fontSize=document.getElementById('font-size').value;
        this.Input();
      },
      SetSpace:function(){
        this.space=document.getElementById('space').value;
        this.Input();
      },
      SetLineWidth:function(){
        this.lineWidth=document.getElementById('linewidth').value;
        this.Input();
      },
      SetlevelSpace:function(){
        this.levelSpace=document.getElementById('level-space').value;
        this.Input();
      },
      SetInput:function(){
        this.code=document.getElementsByClassName('input-box')[0].innerHTML;
        this.Input();
      },
      SetX:function(){
        this.x=document.getElementById('movex').value;
        this.Input();
      },
      SetY:function(){
        this.y=document.getElementById('movey').value;
        this.Input();
      },
      ChangeStyle:function(i){
        this.style[this.curStyle].active=false;
        this.style[i].active=true;
        this.curStyle=i;
      },
      Node(value){
        value=value.replace(/&nbsp;|^\s*|\s*$/g,'');
        if(!value){
          this.message+="不合法的根节点值: null;<br>";
          return null;
        }
        var color=value[value.length-1];
        if((['w','r','b']).indexOf(color)==-1){
          color='w';
        }
        else{
          value=value.substring(0,value.length-1);
        }
        if(value.length>2){
          this.message+="过长的节点值: "+value+";<br>";
          return null;
        }
        return {
          value:value,
          FirstChild:null,
          NextSibling:null,
          posX:0,
          posY:0,
          color:color,
        }
      },
      Input:function(){
        this.message="";
        this.code=document.getElementsByClassName("input-box")[0].innerHTML;
        this.Draw();
      },
      Explain:function(s){
        //找根
        var start=s.indexOf('[');
        var root=null;
        var child=[];
        if(start==-1){//最内层节点
          s=s.split(' ');
          root=this.Node(s.splice(0,1)[0]);
          if(root==null){
            return null;
          }
          if(root.value=='0h'&&s.length!=0){
            this.message+="不合法的根节点: 隐藏节点;<br>";
            return null;
          }
          for(var c in s){
            child.push(this.Node(c));
          }
        }
        else if(start==0){
          this.message+="不合法的表达: '[';<br>"
          return null;
        }
        else{
          root=this.Node(s.substring(0,start));
          if(root==null){
            return null;
          }
          if(root.value=='0h'){
            this.message+="不合法的根节点: 隐藏节点;<br>";
            return null;
          }
          var level=0;
          var end=start;
          for(;end<s.length;end++){
            if(s[end]=='[') level++;
            if(s[end]==']') level--;
            if(level<0){
              this.message+="未闭合的解析式: "+s.substring(start,end)+";<br>";
              return null;
            } 
            if(level==0){
              if(start==end-1){
                this.message+="不合法的节点值: null;<br>";
                return;
              }
              child.push(this.Explain(s.substring(start+1,end)));
              start=end+1;
            } 
          }
          if(level!=0){
            this.message+="未闭合的解析式: "+s+";<br>";
            return null;
          }
        }
        var LastNode=null;       
        for(var i=0;i<child.length;i++){
          if(i==0){
            root.FirstChild=child[i];
            LastNode=root.FirstChild;
          }
          else{
            LastNode.NextSibling=child[i];
            LastNode=LastNode.NextSibling;
          }
        }
        return root;
      },
      CalcPos:function(root){
        //计算每一层的第一个点位置，然后根据点距离和孩子距离选一个大的
        this.Dfs(root,0);
        this.Level[this.Level.length-1][0].posX=0; //最后一层的第一个点
        this.Level[this.Level.length-1][0].posY=this.Level.length-1;
        var NiceNode=0;//最后一层已知第一个节点
        var Last=[];
        for(var i=this.Level.length-1;i>=1;i--){  
          for(var j=NiceNode-1;j>=0;j--){
            this.Level[i][j].posY=i;
            this.Level[i][j].posX=this.Level[i][j+1].posX-1;
          }
          var k=1;
          for(var j=NiceNode+1;j<this.Level[i].length;j++){
            this.Level[i][j].posY=i;
            if(this.Level[i][j].FirstChild==null){
              this.Level[i][j].posX=this.Level[i][j-1].posX+1;
            }
            else{
              this.Level[i][j].posX=this.Level[i][j-1].posX+Math.max(1,Last[k]-Last[k-1]);
              k++;
            }
          }
          var c=this.Level[i][0];//相同父亲的节点
          var sum=this.Level[i][0].posX;//相同父亲节点的偏移之和
          var num=1;//相同父亲节点的个数
          if(this.Level[i].length==1){
            Last=[this.Level[i][0].posX];//不会进入下方循环，所以先算好
          }
          else{
            Last=[];
          }
          for(var j=1;j<this.Level[i].length;j++){
            if(c.NextSibling==this.Level[i][j]){
              num++;
              sum+=this.Level[i][j].posX;
            }
            else{
              Last.push(sum/num); 
              sum=this.Level[i][j].posX;
              num=1;
            }
            c=this.Level[i][j];
          }
          Last.push(sum/num);//最后一次直接退出而没有计算
          for(var j=0;j<this.Level[i-1].length;j++){
            if(this.Level[i-1][j].FirstChild!=null){
              this.Level[i-1][j].posY=i-1;
              this.Level[i-1][j].posX=Last[0];
              NiceNode=j;
              break;
            }
          }
        }
      },
      Dfs(node, level){
        if(level>=this.Level.length){
          this.Level.push.apply(this.Level,Array(level-this.Level.length+1).fill(Array(0)));
        }
        this.Level[level].push(node);
        for(var c=node.FirstChild; c!=null; c=c.NextSibling){
          this.Dfs(c,level+1);
        }
      },
      DrawTree(node){
        if(node.value=='0h'){
          return;
        }
        this.ctx.beginPath();
        this.ctx.lineWidth = this.lineWidth;
        var radius=this.fontSize/1.5;
        this.ctx.arc(node.posX*this.space, node.posY*this.levelSpace, radius, 0, Math.PI*2, true);
        switch(node.color){
          case('r'):
            this.ctx.strokeStyle = "#ff0000";
            this.ctx.stroke();
            this.ctx.fillStyle = "#ff0000";
            this.ctx.fill();
            this.ctx.fillStyle = "#ffffff";
            break;
          case('b'):
            this.ctx.strokeStyle = "#000000";
            this.ctx.stroke();
            this.ctx.fillStyle = "#000000";
            this.ctx.fill();
            this.ctx.fillStyle = "#ffffff";
            break;
          case('w'):
            this.ctx.strokeStyle = "#000000";
            this.ctx.stroke();
            this.ctx.fillStyle = "#ffffff";
            this.ctx.fill();
            this.ctx.fillStyle = "#000000";
            break;
        }
        this.ctx.font="bold "+String(this.fontSize)+"px Times New Roman";
        this.ctx.fillText(node.value, node.posX*this.space-radius*0.35*node.value.length, node.posY*this.levelSpace+radius*0.35);
        for(var c=node.FirstChild;c!=null;c=c.NextSibling){
          if(c.value=='0h'){
            continue;
          }
          this.ctx.beginPath();
          this.ctx.lineWidth = this.lineWidth/2;
          this.ctx.lineJoin = 'round';
          if(node.color=='r'){
            this.ctx.strokeStyle = "#ff0000";
          }
          else{
            this.ctx.strokeStyle = "#000000";
          }
          this.ctx.moveTo(node.posX*this.space,node.posY*this.levelSpace+radius);
          this.ctx.lineTo(c.posX*this.space,c.posY*this.levelSpace-radius);
          this.ctx.stroke();
          this.DrawTree(c);
        }
      },
      Draw(){
        var c=document.getElementsByTagName("canvas")[0];
        this.ctx=c.getContext("2d");
        c.height=c.height;
        this.ctx.save();
        this.ctx.translate(this.x,this.y);
        this.ctx.scale(this.scale,this.scale);
        this.Level=Array(1).fill(Array(0));
        var root=this.Explain(this.code);
        if(root){
          this.CalcPos(root);
          this.DrawTree(root);
        }
        this.ctx.restore();
      }
    },
    computed:{
      CalcRadius:function(){
        var radius=this.font+2;
        return radius;
      },
      OutPut:function(){
        var s=this.message;
        if(s==""){
          s="未发现问题;<br>"
        }
        return s;
      }
    }
}
</script>

<style>
table {
  width: 100%;
  border-collapse: collapse;
  background-color:light-grey;
}
option {
  padding-left: 10px;
}
.title {
  font-size: 30px;
  background-color: coral;
  color: white;
  writing-mode: vertical-lr;
  padding: 5px;
  height: 100%;
  float: left;
  width:40px;
  position: fixed;
}
.container{
  height: 100%;
  width: 90%;
  position: fixed;
  align-content: center;
  padding-left: 45px;
}
.above-container{
  width: 100%;
  height: 300px;
}
.border{
  width: 80%;
  height: 100%;    
  margin-top: 1%;
  border-radius: 5px;  
  margin-left: auto;
  margin-right: auto;
}
.option-container{
    height: 300px;
    width: 25%;
    float: left;
    border: 1pt solid lightgray;
    border-radius: 5px;
}
.table-button {
  width: 100%;
  height: 33px;
  color: grey;
  border: 0px;
  border-radius: 0px 0px 5px 5px;
  background-color: white;
  font-size: 18px;
  padding-top: 5.5px;
}
.table-button.active {
  background-color: coral;
  color: white;
}
.input-container {
    height: 100%;
    width: 60%;
    float: left;
}
.input-box{
    height: 120px;
    width: 97%;
    overflow-x:hidden;
    border: 1pt solid lightgray;
    margin: 5px;
    margin-top: 0%;
    padding: 10px;
    margin-left: 2.5%;
    border-radius: 5px;
    font-family: 'Courier New', Courier, monospace;
}

.output-box{
    height: 120px;
    width: 97%;
    overflow-x:hidden;
    border: 1pt solid lightgray;
    margin: 5px;
    margin-left: 2.5%;
    margin-top: 15px;
    border-radius: 5px;
    padding: 10px;
}

.style-container {
  width: 100px;
  margin-left: 63%;
  position: fixed;
}

.style-list {
    height: 300px;
    width: 100%;
    overflow-x:hidden;
    border: 1pt solid lightgray;
    margin: 0.5%;
    margin-top: 2%;
    margin-left: 15%;
    border-radius: 5px;
}

.style-item{
  font-size: 18px;
  color: grey;
  line-height: 40px;
}
.style-item.active {
  color: white;
  background-color: coral;
}

.hr {
  background-color: lightgrey;
  border: 0.5px solid;
  background-color: lightgrey;
  width: 100%;
}
.item-name {
  width: 20%;
  font-size: 18px;
  padding-left: 2%;
  color: gray;
}
.item-line {
  line-height: 40px;
}
.item-select {
  width: 80%;
  font-size: 18px;
}

canvas {
  border: 1pt solid lightgrey;
  margin-top: 20px;
  margin-left: 10%;
}
</style>